import 'slick-carousel/slick/slick.min';
import set_table_items_height from "./set-table-items-height";

const table_slider = () => {
    if ( $('.dual-column-table').length ) {
        let windowWidth = $(window).width();

        $('.dual-column-table').each(function() {
            let $table = $(this);

            // if items of the same index should have the same height call the setTableItemsHeight() function
            if ($table.hasClass('same-item-height')) {
                set_table_items_height($table);
            }

            // on window resize set item height and refresh slick to generate slider
            $(window).resize(function() {
                windowWidth = $(window).width();

                if ($table.hasClass('same-item-height')) {
                    set_table_items_height($table);
                }
            });
        });
    }
}

export default table_slider;